var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.text
    ? _c("div", { class: _vm.bemBlock }, [
        _c("span", {
          class: _vm.bemElement("text"),
          domProps: { innerHTML: _vm._s(_vm.text) }
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.tooltip,
                expression: "tooltip"
              }
            ],
            ref: "PriceMsgTooltip",
            class: _vm.bemElement("tooltip-container"),
            on: {
              mouseleave: _vm.handleHideTooltip,
              mouseenter: _vm.handleShowTooltip
            }
          },
          [
            _c("i", {
              class: _vm.bemElement("icon"),
              on: { click: _vm.handleShowTooltip }
            })
          ]
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }